export default function mapTag(tagName: string) {

    const allTags = gd.session.projects.allTags().models

    const searchValue: string = tagName.trim().toLowerCase()
    const tag = _.find(allTags, curTag =>
        curTag.name.toLowerCase() === searchValue
    )

    if (tag) {
        return tag.id
    }

    return null
}
